"use client";

import "@/app/(public)/shared/tokens/colors.css";
import "@/app/(public)/shared/tokens/typography.css";
import { Button } from "@/app/(public)/shared/ui/Button";

interface ApplyCardProps {
  /** Posting that holds the application form for this role. */
  applyUrl: string;
}

/**
 * Apply panel beside a job description. It replaces the form we used to host
 * ourselves: our applicant tracking system owns applications now, so the only job
 * here is to hand the candidate over cleanly rather than collect anything. The
 * copy never names the vendor, and the role page header names the role directly
 * above this, so the card does not repeat it.
 *
 * @param applyUrl - Posting the button opens in a new tab.
 * @returns The apply card.
 */
export const ApplyCard = ({ applyUrl }: ApplyCardProps) => {
  // Handlers
  const handleApply = () => {
    window.open(applyUrl, "_blank", "noopener,noreferrer");
  };

  // Render
  return (
    <div className="lg:sticky lg:top-32 flex flex-col gap-6 bg-white rounded-xl p-8 border border-landing-primary">
      <div className="flex flex-col gap-2">
        <h3 className="text-h4 text-landing-primary font-bold">Apply for this role</h3>
        <p className="text-body text-landing-secondary font-medium">The application form opens in a new tab.</p>
      </div>
      <Button variant="primary" color="primary" size="md" onClick={handleApply}>
        Apply now
      </Button>
    </div>
  );
};
